import React, { Component } from 'react';
import { Table, Form, Input, Button } from 'reactstrap';
import { GoCheck } from 'react-icons/go';
import moment from "moment";
import TooltipItem from '../../tools/TooltipItem';

export class AthKeycardFitness extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableData: [],
            popData: [],
            formPop: "0",
            formStartDate: moment().format("YYYY-MM-DD"),//moment() might not necessarily be the way forward, but we have it
                                                            //UPDATE 20240214: The multi-factor authentication upgrade uses moment() prodigiously, so it's the way forward now.
            formEndDate: moment().add(1, 'd').format("YYYY-MM-DD"),
            formMonStart: "00:00:00",//These are defaulted here as these because these values are managing the first row of the table, which functions as a form. Because of the display requirements, they
                                        //aren't part of a single <Form> component which means each field is managed individually
            formMonEnd: "23:59:59",
            formTueStart: "00:00:00",
            formTueEnd: "23:59:59",
            formWedStart: "00:00:00",
            formWedEnd: "23:59:59",
            formThuStart: "00:00:00",
            formThuEnd: "23:59:59",
            formFriStart: "00:00:00",
            formFriEnd: "23:59:59",
            formSatStart: "00:00:00",
            formSatEnd: "23:59:59",
            formSunStart: "00:00:00",
            formSunEnd: "23:59:59",
            dataKey: 1
        }
        this.getTableData();
        this.getPopulations();
    }

    async getTableData() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userData.level
        }
        const response = await fetch('GetAthFitnessData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            tableData: data
        })
    }

    async getPopulations() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userData.level //For second-level components such as these it becomes easier to use props for important things like user data. One day, all components will be inheriting
                                                    //this from App.js
        }
        const response = await fetch('GetAthPopulationList', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            popData: data
        })
    }

    componentDidMount() {

    }

    async addRecord() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {//Welcome to Hell. With all of this form managed in state, we can just grab what we've stored here with no need for event handling.
            userLevel: this.props.userData.level,
            pop: this.state.formPop,
            startdate: this.state.formStartDate,
            enddate: this.state.formEndDate,
            monstart: this.state.formMonStart,
            monend: this.state.formMonEnd,
            tuestart: this.state.formTueStart,
            tueend: this.state.formTueEnd,
            wedstart: this.state.formWedStart,
            wedend: this.state.formWedEnd,
            thustart: this.state.formThuStart,
            thuend: this.state.formThuEnd,
            fristart: this.state.formFriStart,
            friend: this.state.formFriEnd,
            satstart: this.state.formSatStart,
            satend: this.state.formSatEnd,
            sunstart: this.state.formSunStart,
            sunend: this.state.formSunEnd
        }
        const response = await fetch('AddAthFitnessPop', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            tableData: data,
            dataKey: this.state.dataKey + 1
        })
    }

    async changeValue(pk, target, value) {//This needs to have as one of its parameters the exact same name as the field, because this is being handled by dynamic SQL and it needs the exact name of what it should be updating
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userData.level,
            pk: pk,
            target: target,
            value: value 
        }
        const response = await fetch('UpdateAthFitness', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            tableData: data,
            dataKey: this.state.dataKey + 1
        })
    }

    async deleteRecord(pk) {//This, we only need the PK for.
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.props.userData.level,
            targetpk: pk 
        }
        const response = await fetch('DeleteAthFitness', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            tableData: data,
            dataKey: this.state.dataKey + 1
        })
    }

    render() {//todo: should this be split into two functional components, one for the form and one for the data?
        return (//This first are is governing the form to add a new record. It looks almost exactly like the data areas.
            <div>
                <h2>Fitness</h2>
                <Table striped>
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ "width": "33%" }}>
                                <Table borderless>
                                    <tbody>
                                        <tr><td><p/></td></tr>
                                        <tr>
                                            <td>
                                                <Input type="select" name="pop" id="pop" value={this.state.formPop} onChange={(e) => this.setState({formPop: e.target.value})}>
                                                    <option value="0" disabled>Select Population</option>
                                                    {this.state.popData.map(item => (
                                                        <option value={item.pk}>{item.popname}</option>
                                                    ))}
                                                </Input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Start Date&emsp;&emsp;<Input type="date" name="startdate" id="startdate" value={this.state.formStartDate} onChange={(e) => this.setState({formStartDate: e.target.value}) } /></td>
                                        </tr>
                                        <tr>
                                            <td>End Date&emsp;&emsp;<Input type="date" name="enddate" id="enddate" value={this.state.formEndDate} onChange={(e) => this.setState({formEndDate: e.target.value}) } /></td>
                                        </tr>
                                        <tr>
                                            <td><Button color="success" onClick={this.addRecord.bind(this)}>Add</Button></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </td>
                            <td style={{ "width": "33%" }}>
                                <Table borderless>
                                    <tbody>
                                        <tr>
                                            <td></td>
                                            <td>Start Time</td>
                                            <td>End Time</td>
                                        </tr>
                                        <tr>
                                            <td>Mondays</td>
                                            <td><Input type="time" name="mon_starttime" id="mon_starttime" value={this.state.formMonStart} onChange={(e) => this.setState({formMonStart: e.target.value}) } /></td>
                                            <td><Input type="time" name="mon_endtime" id="mon_endtime" value={this.state.formMonEnd} onChange={(e) => this.setState({formMonEnd: e.target.value}) } /></td>
                                        </tr>
                                        <tr>
                                            <td>Tuesdays</td>
                                            <td><Input type="time" name="tue_starttime" id="tue_starttime" value={this.state.formTueStart} onChange={(e) => this.setState({formTueStart: e.target.value}) } /></td>
                                            <td><Input type="time" name="tue_endtime" id="tue_endtime" value={this.state.formTueEnd} onChange={(e) => this.setState({formTueEnd: e.target.value}) } /></td>
                                        </tr>
                                        <tr>
                                            <td>Wednesdays</td>
                                            <td><Input type="time" name="wed_starttime" id="wed_starttime" value={this.state.formWedStart} onChange={(e) => this.setState({formWedStart: e.target.value}) } /></td>
                                            <td><Input type="time" name="wed_endtime" id="wed_endtime" value={this.state.formWedEnd} onChange={(e) => this.setState({formWedEnd: e.target.value}) } /></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </td>
                            <td style={{ "width": "33%" }}>
                                <Table borderless>
                                    <tbody>
                                        <tr>
                                            <td></td>
                                            <td>Start Time</td>
                                            <td>End Time</td>
                                        </tr>
                                        <tr>
                                            <td>Thursdays</td>
                                            <td><Input type="time" name="thu_starttime" id="thu_starttime" value={this.state.formThuStart} onChange={(e) => this.setState({formThuStart: e.target.value}) } /></td>
                                            <td><Input type="time" name="thu_endtime" id="thu_endtime" value={this.state.formThuEnd} onChange={(e) => this.setState({formThuEnd: e.target.value}) } /></td>
                                        </tr>
                                        <tr>
                                            <td>Fridays</td>
                                            <td><Input type="time" name="fri_starttime" id="fri_starttime" value={this.state.formFriStart} onChange={(e) => this.setState({formFriStart: e.target.value}) } /></td>
                                            <td><Input type="time" name="fri_endtime" id="fri_endtime" value={this.state.formFriEnd} onChange={(e) => this.setState({formFriEnd: e.target.value}) } /></td>
                                        </tr>
                                        <tr>
                                            <td>Saturdays</td>
                                            <td><Input type="time" name="sat_starttime" id="sat_starttime" value={this.state.formSatStart} onChange={(e) => this.setState({formSatStart: e.target.value}) } /></td>
                                            <td><Input type="time" name="sat_endtime" id="sat_endtime" value={this.state.formSatEnd} onChange={(e) => this.setState({formSatEnd: e.target.value}) } /></td>
                                        </tr>
                                        <tr>
                                            <td>Sundays</td>
                                            <td><Input type="time" name="sun_starttime" id="sun_starttime" value={this.state.formSunStart} onChange={(e) => this.setState({formSunStart: e.target.value}) } /></td>
                                            <td><Input type="time" name="sun_endtime" id="sun_endtime" value={this.state.formSunEnd} onChange={(e) => this.setState({formSunEnd: e.target.value}) } /></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </td>
                        </tr>
                        {this.state.tableData.length > 0 && this.state.tableData.map(item => (//Here wer'e actually displaying Real Data. We're also including a conditional for attempting to render when there's no data to render
                            <tr >
                                <td style={{ "width": "33%" }}>
                                    <Table borderless>
                                        <tbody>
                                            <tr><td><p /></td></tr>
                                            <tr>
                                                <td>
                                                    <TooltipItem id={item.pk} title={item.description.replaceAll("|", "\n")}>
                                                    <h3>{item.popname}</h3>
                                                    </TooltipItem>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Start Date&emsp;&emsp;<Input type="date" name="startdate" id="startdate" defaultValue={item.startdate} onBlur={(e) => {
                                                    if (e.target.value != item.startdate) { this.changeValue(item.pk, "StartDate", e.target.value) }
                                                }} /></td>
                                            </tr>
                                            <tr>
                                                <td>End Date&emsp;&emsp;<Input type="date" name="enddate" id="enddate" defaultValue={item.enddate} onBlur={(e) => {
                                                    if (e.target.value != item.enddate) { this.changeValue(item.pk, "EndDate", e.target.value) }
                                                }} /></td>
                                            </tr>
                                            <tr>
                                                <td><Button color="danger" onClick={(e) => this.deleteRecord(item.pk)}>Delete</Button></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                                <td style={{ "width": "33%" }}>
                                    <Table borderless>
                                        <tbody>
                                            <tr>
                                                <td></td>
                                                <td>Start Time</td>
                                                <td>End Time</td>
                                            </tr>
                                            <tr>
                                                <td>Mondays</td>
                                                <td><Input type="time" name="mon_starttime" id="mon_starttime" defaultValue={item.mon_starttime} onBlur={(e) => this.changeValue(item.pk, "Mon_StartTime", e.target.value)} /></td>
                                                <td><Input type="time" name="mon_endtime" id="mon_endtime" defaultValue={item.mon_endtime} onBlur={(e) => this.changeValue(item.pk, "Mon_EndTime", e.target.value)} /></td>
                                            </tr>
                                            <tr>
                                                <td>Tuesdays</td>
                                                <td><Input type="time" name="tue_starttime" id="tue_starttime" defaultValue={item.tue_starttime} onBlur={(e) => this.changeValue(item.pk, "Tue_StartTime", e.target.value)} /></td>
                                                <td><Input type="time" name="tue_endtime" id="tue_endtime" defaultValue={item.tue_endtime} onBlur={(e) => this.changeValue(item.pk, "Tue_EndTime", e.target.value)} /></td>
                                            </tr>
                                            <tr>
                                                <td>Wednesdays</td>
                                                <td><Input type="time" name="wed_starttime" id="wed_starttime" defaultValue={item.wed_starttime} onBlur={(e) => this.changeValue(item.pk, "Wed_StartTime", e.target.value)} /></td>
                                                <td><Input type="time" name="wed_endtime" id="wed_endtime" defaultValue={item.wed_endtime} onBlur={(e) => this.changeValue(item.pk, "Wed_EndTime", e.target.value)} /></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                                <td style={{ "width": "33%" }}>
                                    <Table borderless>
                                        <tbody>
                                            <tr>
                                                <td></td>
                                                <td>Start Time</td>
                                                <td>End Time</td>
                                            </tr>
                                            <tr>
                                                <td>Thursdays</td>
                                                <td><Input type="time" name="thu_starttime" id="thu_starttime" defaultValue={item.thu_starttime} onBlur={(e) => this.changeValue(item.pk, "Thu_StartTime", e.target.value)} /></td>
                                                <td><Input type="time" name="thu_endtime" id="thu_endtime" defaultValue={item.thu_endtime} onBlur={(e) => this.changeValue(item.pk, "Thu_EndTime", e.target.value)} /></td>
                                            </tr>
                                            <tr>
                                                <td>Fridays</td>
                                                <td><Input type="time" name="fri_starttime" id="fri_starttime" defaultValue={item.fri_starttime} onBlur={(e) => this.changeValue(item.pk, "Fri_StartTime", e.target.value)} /></td>
                                                <td><Input type="time" name="fri_endtime" id="fri_endtime" defaultValue={item.fri_endtime} onBlur={(e) => this.changeValue(item.pk, "Fri_EndTime", e.target.value)} /></td>
                                            </tr>
                                            <tr>
                                                <td>Saturdays</td>
                                                <td><Input type="time" name="sat_starttime" id="sat_starttime" defaultValue={item.sat_starttime} onBlur={(e) => this.changeValue(item.pk, "Sat_StartTime", e.target.value)} /></td>
                                                <td><Input type="time" name="sat_endtime" id="sat_endtime" defaultValue={item.sat_endtime} onBlur={(e) => this.changeValue(item.pk, "Sat_EndTime", e.target.value)} /></td>
                                            </tr>
                                            <tr>
                                                <td>Sundays</td>
                                                <td><Input type="time" name="sun_starttime" id="sun_starttime" defaultValue={item.sun_starttime} onBlur={(e) => this.changeValue(item.pk, "Sun_StartTime", e.target.value)} /></td>
                                                <td><Input type="time" name="sun_endtime" id="sun_endtime" defaultValue={item.sun_endtime} onBlur={(e) => this.changeValue(item.pk, "Sun_EndTime", e.target.value)} /></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                                </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    }
}